import { Ability, AbilityClass } from "@casl/ability";
import { RoleEnum } from "@/classes/role";
import Vue from "vue";

// Front end permission handling with CASL/Vue
// https://www.npmjs.com/package/@casl/vue
// https://casl.js.org/v4/en/advanced/typescript

type Actions = "manage" | "read";

export type AppAbility = Ability<[Actions, RoleEnum]>;
export const AppAbility = Ability as AbilityClass<AppAbility>;
export const AppAbilityService = new Vue({
  data: new AppAbility()
}).$data;

export const AppAbilityChecker = {
  canViewAsAdmin() {
    if (AppAbilityService.rules.length === 0) return false;
    return AppAbilityService.can("read", RoleEnum.All);
  },
  canEditAsAdmin() {
    return AppAbilityService.can("manage", RoleEnum.All);
  },
  canViewAsSupport() {
    return AppAbilityService.can("read", RoleEnum.Support);
  },
  canEditAsSupport() {
    return AppAbilityService.can("manage", RoleEnum.Support);
  },
  canViewAsOrganization() {
    return this.canEditAsAdmin || AppAbilityService.can("read", RoleEnum.Organization);
  },
  canEditAsOrganization() {
    return this.canEditAsAdmin || AppAbilityService.can("manage", RoleEnum.Organization);
  },
  canViewAsProperty() {
    return (
      this.canEditAsAdmin ||
      AppAbilityService.can("read", RoleEnum.Organization) ||
      AppAbilityService.can("read", RoleEnum.Property)
    );
  },
  canEditAsProperty() {
    return (
      this.canEditAsAdmin ||
      AppAbilityService.can("manage", RoleEnum.Organization) ||
      AppAbilityService.can("manage", RoleEnum.Property)
    );
  }
};
